"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ThemeProvider = require("../ThemeProvider");
var _ResponsiveProp = _interopRequireDefault(require("./ResponsiveProp"));
var _ResponsiveWithMediaQueryStyleSheet = _interopRequireDefault(require("./ResponsiveWithMediaQueryStyleSheet"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Responsive conditionally renders children based on whether the viewport matches the provided
 * min and max viewports.
 *
 * If enableMediaQueryStyleSheet themeOption is set to false in ThemeProvider, then in SSR,
 * like other viewport utilities, it treats the viewport as `xs` both in SSR itself and
 * during first hydration on the client side; then if the viewport is not `xs`, it re-renders
 * after hydration. This may cause a layout shift on devices other than the narrowest.
 *
 * If enableMediaQueryStyleSheet themeOption is set to true in ThemeProvider, then media query stylesheet
 * is used to hide and show children of `Responsive` within a View.
 */const Responsive = /*#__PURE__*/_react.default.forwardRef((_ref, ref) => {
  let {
    min = 'xs',
    max,
    inheritedStyles = [],
    children
  } = _ref;
  const {
    themeOptions: {
      enableMediaQueryStyleSheet
    }
  } = (0, _ThemeProvider.useTheme)();
  if (enableMediaQueryStyleSheet) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ResponsiveWithMediaQueryStyleSheet.default, {
      inheritedStyles: inheritedStyles,
      min: min,
      max: max,
      ref: ref,
      children: children
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ResponsiveProp.default, {
    min: min,
    max: max,
    children: children
  });
});
Responsive.displayName = 'Responsive';
Responsive.propTypes = {
  /**
   * To hide children of `Responsive` if the current viewport is smaller than `min`
   */
  min: _propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
  /**
   * To hide children of `Responsive` if the current viewport is larger than `max`
   */
  max: _propTypes.default.oneOf(['sm', 'md', 'lg', 'xl']),
  /**
   * Styles to be inherited by `Responsive`.
   * It should be an array of style property names.
   * Note: This prop is only applicable when `enableMediaQueryStylesheet` is set to true in the `ThemeProvider`.
   */
  inheritedStyles: _propTypes.default.arrayOf(_propTypes.default.string),
  children: _propTypes.default.node.isRequired
};
var _default = exports.default = Responsive;